<template>
  <div class="orders">
    <div class="title">
      <p>{{ this.$store.state.titles }}</p>
    </div>
    <div class="main">
      <el-card class="mb10">
        <!-- <span> <el-input v-model="phone" style="width: 240px" placeholder="请输入下单手机号" clearable></el-input> </span> -->
        <span> <el-input v-model="ordernumber" style="width: 240px" placeholder="请输入订单号码" clearable></el-input> </span>
        <!-- <span v-show="activeName == '1'">
                    <el-select v-model="status" style="width: 240px" placeholder="请选择订单状态" @change="statusChange">
                        <el-option value="0" label="全部"></el-option>
                        <el-option value="1" label="待付款"></el-option>
                        <el-option value="2" label="待发货"></el-option>
                        <el-option value="3" label="待收货"></el-option>
                        <el-option value="4" label="已完成"></el-option>
                        <el-option value="5" label="已取消"></el-option>
                    </el-select>
                </span> -->
        <span>
          <el-button type="primary" @click="rufsh">搜索</el-button>
        </span>
        <span>
          <el-button type="primary" @click="init">重置</el-button>
        </span>
        <span>
          <el-button type="success" @click="bindData" :loading="disbtn">导出</el-button>
        </span>
      </el-card>

      <el-card>
        <div class="table">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <!-- <el-tab-pane label="全部订单" name="sj">
                            <list
                                ref="list"
                                @shipShow="shipShow"
                                v-if="activeName == 'sj'"
                                :key="isinit"
                                @hide="hide"
                                :isAll="false"
                                :phone="phone"
                                :ordernumber="ordernumber"
                                :status="status"
                                @bindData="bindData"
                                @logisticsDetailShow="logisticsDetailShow"
                            />
                        </el-tab-pane> -->
            <el-tab-pane v-for="(item, index) in StatusBar" :key="index" :label="item.name" :name="item.value">
              <listChild
                ref="listBlo"
                v-if="activeName == item.value"
                @logisticsDetailShow="logisticsDetailShow"
                @opendetails="opendetails"
                @shipShow="shipShow"
                :key="isinit"
                :isAll="true"
                @hide="hide"
                :phone="phone"
                :status="status"
                :ordernumber="ordernumber"
                @bindData="bindData"
              />
              <!-- v-if="activeName == 'all'" -->
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-card>
    </div>
    <detail @hide="hide" :datas="datas" v-if="dialogFormVisible" />
    <Ship ref="refShip"></Ship>
    <LogisticsDetail ref="refLogisticsDetail" :logistics_token="logistics_token"></LogisticsDetail>
    <OrderDetails ref="orderdetails" :statue="status"></OrderDetails>
  </div>
</template>
<script>
import listChild from "./component/list.vue";
import Detail from "./component/detail.vue";
import LogisticsDetail from "@/components/Modules/Order/logisticsDetail.vue";
import Ship from "@/components/Modules/Order/Ship.vue";
import OrderDetails from "@/components/Modules/Order/confirmDialog.vue";
import { mapActions } from "vuex";
export default {
  data() {
    return {
      disbtn: false,
      activeName: "0",
      phone: "",
      ordernumber: "",
      status: "0",
      dialogFormVisible: false,
      isinit: 1,
      allprice: "",
      price: "",
      datas: "",
      dataList: [],
      infoData: {},
      logistics_token: "",
      StatusBar: [
        { name: "全部订单", value: "0" },
        { name: "未支付", value: "1" },
        { name: "待发货", value: "2" },
        { name: "待收货", value: "3" },
        { name: "待评价", value: "4" },
        { name: "已取消", value: "5" },
        { name: "已完成", value: "6" },
        { name: "已关闭", value: "7" }
      ]
    };
  },
  components: {
    listChild,
    Detail,
    Ship,
    LogisticsDetail,
    OrderDetails
  },
  created() {
    // this.Bind();
    this.getLogisticsToken();
  },
  methods: {
    // getYourIP(){
    //     var RTCPeerConnection = window.RTCPeerConnection || window.webkitRTCPeerConnection || window.mozRTCPeerConnection;
    //     if (RTCPeerConnection) (function () {
    //         var rtc = new RTCPeerConnection({iceServers:[]});
    //         if (1 || window.mozRTCPeerConnection) {
    //             rtc.createDataChannel('', {reliable:false});
    //         }
    //         rtc.onicecandidate = function (evt) {
    //             if (evt.candidate) grepSDP("a="+evt.candidate.candidate);
    //         };
    //         rtc.createOffer(function (offerDesc) {
    //             grepSDP(offerDesc.sdp);
    //             rtc.setLocalDescription(offerDesc);
    //         }, function (e) { console.warn("offer failed", e); });
    //         var addrs = Object.create(null);
    //         addrs["0.0.0.0"] = false;
    //         function updateDisplay(newAddr) {
    //             if (newAddr in addrs) return;
    //             else addrs[newAddr] = true;
    //             var displayAddrs = Object.keys(addrs).filter(function (k) { return addrs[k]; });
    //             for(var i = 0; i < displayAddrs.length; i++){
    //                 if(displayAddrs[i].length > 16){
    //                     displayAddrs.splice(i, 1);
    //                     i--;
    //                 }
    //             }
    //             document.getElementById('list').textContent = displayAddrs[0];
    //         }
    //         function grepSDP(sdp) {
    //             var hosts = [];
    //             sdp.split('\r\n').forEach(function (line, index, arr) {
    //                 if (~line.indexOf("a=candidate")) {
    //                     var parts = line.split(' '),
    //                         addr = parts[4],
    //                         type = parts[7];
    //                     if (type === 'host') updateDisplay(addr);
    //                 } else if (~line.indexOf("c=")) {
    //                     var parts = line.split(' ')[2],
    //                     updateDisplay(parts);
    //                 }
    //             });
    //         }
    //     })();
    //     else{
    //         document.getElementById('list').textContent = "请使用主流浏览器：chrome,firefox,opera,safari";
    //     }
    // },
    ...mapActions({
      getOrderPrice: "commodity/getOrderPrice",
      getOrderDetails: "commodity/getOrderDetails",
      getOrderList: "commodity/getOrderList",
      logisticsToken: "commodity/logisticsToken",
      getBeiOrderList: "commodity/getBeiOrderList" //修改成为北京查询列表接口
    }),
    getLogisticsToken() {
      this.logisticsToken({ token: this.$store.state.token }).then(res => {
        if (res.code == 1) {
          this.logistics_token = res.data.token;
        }
      });
    },
    opendetails(item) {
      //确认是否弹框的事件
      this.$refs.orderdetails.dialogVisible = true;
    },
    logisticsDetailShow(item) {
      this.$refs.refLogisticsDetail.dialogVisible = true;
      this.$refs.refLogisticsDetail.getList(item);
    },
    async shipShow(item) {
      this.$refs.refShip.dialogVisible = true;
      await this.$refs.refShip.getList(item);
    },
    statusChange() {
      this.$nextTick(() => {
        this.$refs.listBlo[0].Bind(1);
      });
    },
    rufsh() {
      this.$refs.listBlo[0].Bind(1);
    },
    // Bind() {
    //     this.getOrderPrice({ token: this.$store.state.token }).then((res) => {
    //         if (res.code == 1) {
    //             if (res.data) {
    //                 this.allprice = res.data.all;
    //                 this.price = res.data.deduction_withdraw;
    //             }
    //         } else {
    //             this.$message.error(res.msg);
    //         }
    //     });
    // },
    init() {
      if (this.isinit == 1) this.isinit = 2;
      else this.isinit = 1;
      this.phone = "";
      this.ordernumber = "";
      this.$refs.listBlo[0].Bind(1);
    },
    hide(val) {
      // this.ordersid=parseInt(val);
      if (val) {
        const loading = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        this.getOrderDetails({
          token: this.$store.state.token,
          id: parseInt(val)
        }).then(res => {
          loading.close();
          if (res.code == 1) {
            this.datas = res.data;
            this.dialogFormVisible = true;
          } else {
            this.$message.error(res.msg);
          }
        });
      } else {
        this.dialogFormVisible = false;
      }
    },
    handleClick(tab, event) {
      this.status = tab.name;
      this.phone = "";
      this.ordernumber = "";
    },
    getFieldStr(index, arr) {
      return arr[index];
    },
    // 绑定list
    bindData() {
      this.disbtn = true;
      let data = {
        token: this.$store.state.token, //用户登录token
        order_by: "id desc", //排序 字段名+空格+排序：“id asc”；asc-正序：可不拼接；desc-倒序
        page_size: 500, //每页记录数
        page: 1, //页数
        buyers_mobile: this.phone, //买家电话
        orders_sn: this.ordernumber, //订单编号
        orders_status: this.status == 0 ? null : this.status
      };
      if (this.activeName == "1") {
        data.orders_status = 2;
      }
      this.getOrderList(data).then(async res => {
        this.disbtn = false;
        if (res.code == 1) {
          // this.dataList.splice(0, this.dataList.length);
          // this.dataList = res.data.list;
          // this.dataList.forEach((item) => {
          //     item.address =
          //         item.orders_deliveries.receivers_provinces + item.orders_deliveries.receivers_citys + item.orders_deliveries.receivers_districts + item.orders_deliveries.receivers_address;
          //     item.receivers_names = item.orders_deliveries.receivers_names;
          //     item.receivers_mobiles = item.orders_deliveries.receivers_mobiles;
          //     item.company_name = item.users_merchant.company_name;
          //     item.goods_names = item.orders_goods.goods_names;
          //     item.goods_number = item.orders_goods.goods_number;
          //     item.goods_payments_amounts = item.orders_goods.goods_payments_amounts;
          //     //  1-未支付 2-付款中 3-已支付
          //     item.trades_status_str = this.getFieldStr(item.trades_status - 1, ["未支付", "付款中", "已支付"]);
          //     //    1-已下单/代付款 2-已支付/代发货 3-已发货/待收货 4-已完成 5-已取消
          //     item.orders_status_str = this.getFieldStr(item.orders_status - 1, ["待付款", "待发货", "待收货", "已完成", "已取消"]);
          // });
          // this.dataList.splice(0, this.dataList.length);
          // this.dataList = [];
          // if (res.data.list && res.data.list.length > 0) {
          //     res.data.list.forEach((item) => {
          //         if (item.orders_goods && item.orders_goods.length > 0) {
          //             item.orders_goods.forEach((val) => {
          //                 let goods = JSON.parse(JSON.stringify(item));
          //                 goods.goods_item = val;
          //                 this.dataList.push(goods);
          //             });
          //         } else {
          //             this.dataList.push(item);
          //         }
          //     });
          //     // this.dataList.forEach((item) => {
          //     //     item.address =
          //     //         item.orders_deliveries.receivers_provinces +
          //     //         item.orders_deliveries.receivers_citys +
          //     //         item.orders_deliveries.receivers_districts +
          //     //         item.orders_deliveries.receivers_address;
          //     //     item.receivers_names = item.orders_deliveries.receivers_names;
          //     //     item.receivers_phones = item.orders_deliveries.receivers_phones;
          //     //     item.company_name = item.users_merchant.company_name;
          //     //     item.goods_names = item.goods_item.goods_names;
          //     //     item.goods_number = item.goods_item.goods_number;
          //     //     item.goods_payments_amounts = item.goods_item.goods_payments_amounts;
          //     //     //  1-未支付 2-付款中 3-已支付
          //     //     item.trades_status_str = this.getFieldStr(item.trades_status - 1, ["未支付", "付款中", "已支付"]);
          //     //     //    1-已下单/代付款 2-已支付/代发货 3-已发货/待收货 4-已完成 5-已取消
          //     //     item.orders_status_str = this.getFieldStr(item.orders_status - 1, ["待付款", "待发货", "待收货", "已完成", "已取消"]);
          //     // });
          // }
        } else {
          this.$message.error(res.msg);
        }
        this.$refs.listBlo[0].ExportWord();
      });
    },
    // 导出
    ExportWord() {
      // if (this.dataList.length == 0) {
      //     return this.$message.error("空数组！");
      // }
      // this.disbtn = true;
      this.getExcel(this.dataList);
    },
    getExcel(arr) {
      require.ensure([], () => {
        // 这里 require 的地址指向你项目中 Export2Excel.js 文件存放地址
        const { export_json_to_excel } = require("../../../excel/Export2Excel.js");
        const tHeader = ["订单详情", "用户", "订单金额", "实付金额", "支付通道", "支付时间"];
        const filterVal = ["title", "userName", "payPrice", "priceOrder", "payMethod", "payTime"];
        const data = this.formatJson(filterVal, arr);
        export_json_to_excel(tHeader, data, "订单管理数据");
        this.disbtn = false;
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    }
  }
};
</script>
<style lang="scss" scoped>
.orders {
  position: relative;
  height: 100%;
}
.title {
  box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
  width: 100%;
  background: #fff;
  padding: 15px 32px;
  display: flex;
  align-items: center;
  p {
    font-size: 16px;
    color: #333;
    margin-left: 32px;
    span {
      color: #e72f0d;
      padding: 0 5px;
    }
    &:first-child {
      font-size: 18px;
      color: #333;
      margin-left: 0;
    }
    &:nth-child(2) {
      span {
        color: #2448ff;
      }
    }
  }
}
::v-deep .el-tabs__item {
  padding: 0 42px !important;
}
::v-deep .el-tabs__active-bar {
  width: 126px !important;
  left: -43px;
}
.main {
  margin: 24px;
  min-width: 1200px;
  span {
    margin-right: 10px;
    ::v-deep .el-input {
      width: 150px;
      display: inline-block;
    }
  }
}
.mb10 {
  margin-bottom: 10px;
}
</style>
